export const token = {
  // ETH
  '0xc7AD46e0b8a400Bb3C915120d284AafbA8fc4735': {
    name: 'DAI',
    fullName: 'Dai Stablecoin (DAI)',
  },
  '0x6B175474E89094C44Da98b954EedeAC495271d0F': {
    name: 'DAI',
    fullName: 'Dai Stablecoin (DAI)',
  },
  '0x190a53B1D685f9A2CFA0007143B64447B64F8e9D': {
    name: 'LCH',
    fullName: 'Lounching Token (LCH)',
  },
  '0x5D49d929173c5c3E2add6E0416C102E4d31CafF5': {
    name: 'sTAUR',
    fullName: 'Synthetic Marnotaur (sTAUR)',
  },
  // BSC testnet
  '0x828C88f841dBEEB7aE293fD2cD8c1B9AeD0cb16c': {
    name: 'DAI',
    fullName: 'DAI',
  },
  '0x399E64578466739232886D19c6E90C8B725b37Ed': {
    name: 'launching',
    fullName: 'LCH',
  },
  '0x214BEd62048F5736b1A05d53d95cCde84145a7d1': {
    name: 'BUSD',
    fullName: 'BUSD',
  },
  '0xd91fdB098a2813d2a517Bb92C0Fb484c36edF075': {
    name: 'sSENATE',
    fullName: 'sSENATE',
  },
  '0x580e1B5a1aade156DC4CdC8b8C45fb0A005c3516': {
    name: 'sSIDUS',
    fullName: 'sSIDUS',
  },
  '0xd8bf7fF99178Cd3b33eBCEB545aE5E70cDaE874a': {
    name: 'DNT',
    fullName: 'DNT',
  },
  '0x4D5AA804Da024Fb4635af951955648274FeA823A': {
    name: 'sLGX',
    fullName: 'sLGX',
  },
  // BSC mainnet
  '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56': {
    name: 'BUSD',
    fullName: 'BUSD',
  },
  '0xea991d5633Ec86756F1c08d23982b26F2F7FFeA7': {
    name: 'sSENATE',
    fullName: 'sSENATE',
  },
  '0x54b4A66624039E0455c6369875Df6bbDA231Ee88': {
    name: 'sSIDUS',
    fullName: 'sSIDUS',
  },
  '0xd36bb7849a8c50b509bae872f44d5c1c7dc0e96c': {
    name: 'CCASH',
    fullName: 'CCASH',
  },
  '0xA25441A567aFf328090Ada0c2b24337159271065': {
    name: 'sPGK',
    fullName: 'sPGK',
  },
  '0x6e89f6b56bd48969A7eeaDa99183AF2d29f77A4F': {
    name: 'sLGX',
    fullName: 'sLGX',
  },
  '0x607D5D2ae03318f001C3add3A93Af2E1F32264BC': {
    name: 'siCADE',
    fullName: 'siCADE',
  },
  '0x05B89E30b2CD81BC4d1d0aca0Dde63a75d4a6c0c': {
    name: 'WARP',
    fullName: 'WARP',
  },
  '0x7De3E1cD8D433d5C3F8c5029a3917cDE0Cd8ff4f': {
    name: 'sWARP',
    fullName: 'sWARP',
  },
  '0xe17CdF489a93718Bfb4F30f379023dfC4ecdF82F': {
    name: 'sSLEEP',
    fullName: 'sSLEEP',
  },
};

export const locker = {
  1: {
    saleChainId: 56,
    saleId: 'sidus',
    lockerChain: 'Ethereum',
    startDate: '2022-15-01',
    endDate: '2022-15-09',
    unlockSchedule: [
      {
        date: '15.12.2021',
        label: 'TGE',
        passed: true,
        percent: '10',
      },
      {
        date: '15.01.2022',
        passed: true,
        percent: '10',
      },
      {
        date: '15.02.2022',
        passed: true,
        percent: '10',
      },
      {
        date: '15.03.2022',
        passed: true,
        percent: '10',
      },
      {
        date: '15.04.2022',
        passed: true,
        percent: '10',
      },
      {
        date: '15.05.2022',
        passed: false,
        percent: '10',
      },
      {
        date: '15.06.2022',
        passed: false,
        percent: '10',
      },
      {
        date: '15.07.2022',
        passed: false,
        percent: '10',
      },
      {
        date: '15.08.2022',
        passed: false,
        percent: '10',
      },
      {
        date: '15.09.2022',
        passed: false,
        percent: '10',
      },
    ],
  },
  2: {
    saleChainId: 56,
    saleId: 'senate',
    lockerChain: 'Ethereum',
    startDate: '2022-15-01',
    endDate: '2022-15-09',
    unlockSchedule: [
      {
        date: '15.12.2021',
        label: 'TGE',
        passed: true,
        percent: '10',
      },
      {
        date: '15.01.2022',
        passed: true,
        percent: '10',
      },
      {
        date: '15.02.2022',
        passed: true,
        percent: '10',
      },
      {
        date: '15.03.2022',
        passed: true,
        percent: '10',
      },
      {
        date: '15.04.2022',
        passed: true,
        percent: '10',
      },
      {
        date: '15.05.2022',
        passed: false,
        percent: '10',
      },
      {
        date: '15.06.2022',
        passed: false,
        percent: '10',
      },
      {
        date: '15.07.2022',
        passed: false,
        percent: '10',
      },
      {
        date: '15.08.2022',
        passed: false,
        percent: '10',
      },
      {
        date: '15.09.2022',
        passed: false,
        percent: '10',
      },
    ],
  },
};

export const products = {
  sidus: {
    id: 1,
    chainId: 56,
    lockerId: 1,
    icon: 'sidus',
    // Token info
    name: 'Sidus (SIDUS)',
    tokenTicker: 'SIDUS',
    address: '0x549020a9Cb845220D66d3E9c6D9F9eF61C981102',
    addressLink: 'https://etherscan.io/token/0x549020a9Cb845220D66d3E9c6D9F9eF61C981102',
    totalSupply: '30,000,000,000 SIDUS',
    // Pooll info
    totalRaise: '$55,000',
    totalOfferingAmount: '30,555,555 SIDUS',
    paymentToken: 'BUSD',
    paymentTokenIcon: 'busd',
    paymentTokenLink: 'https://bscscan.com/token/0xe9e7cea3dedca5984780bafc599bd69add087d56',
    price: '$0.0018 ',
    // Sale campaign details
    time: '07:00 UTC',
    date: 'December, 15th',
    vestingInfo: 'TGE 10%, month unlock - 10%',
    dateTGE: 'TBA',
    distributionInfo: 'TGE - manual distribution, later can be switched to claim',
    saleBlockchain: 'Binance Smart Chain',
    distributionBlockchain: 'Ethereum',
    minimunStake: '5k MILK2',
    maximumStake: '20k MILK2',
    participantsLimit: '1000',
    participationRestrictions: 'General',
    // Tokensale page info
    exchangeRate: '1 sSIDUS= 0.0018 BUSD',
    description:
      'A Futuristic PLAY2EARN NFT MMORPG with an amazing blockchain journey full of adventures and opportunities',
    socialLinks: [
      {
        icon: 'www',
        link: 'https://sidusheroes.com/',
      },
      {
        icon: 'telegram',
        link: 'https://t.me/sidus_heroes',
      },
      {
        icon: 'twitter',
        link: 'https://twitter.com/galaxy_sidus',
      },
      {
        icon: 'discord',
        link: 'https://discord.gg/PGD4bq7jE4',
      },
      {
        icon: 'medium',
        link: 'https://medium.com/sidus-nft-heroes',
      },
      {
        icon: 'youtube',
        link: 'https://www.youtube.com/channel/UCK3TsqpWwMkve49sOZD_gmg/featured',
      },
    ],
    saleType: 'IDO',
    stakeToken: 'milk2',
    progress: 96.8,
    hasClaim: false,
    xxx: 109.29,
    roi: '+10 828.5%',
    isFinished: true,
  },
  senate: {
    id: 2,
    lockerId: 2,
    chainId: 56,
    icon: 'senate',
    // Token info
    name: 'Sidus (SENATE)',
    tokenTicker: 'SENATE',
    address: '0x34Be5b8C30eE4fDe069DC878989686aBE9884470',
    addressLink: 'https://etherscan.io/token/0x34Be5b8C30eE4fDe069DC878989686aBE9884470',
    totalSupply: '300,000,000 SENATE',
    // Pooll info
    totalRaise: '$55,000',
    totalOfferingAmount: '305,555 SENATE',
    paymentToken: 'BUSD',
    paymentTokenIcon: 'busd',
    paymentTokenLink: 'https://bscscan.com/token/0xe9e7cea3dedca5984780bafc599bd69add087d56',
    price: '$0.18',
    // Sale campaign details
    time: '07:00',
    date: 'December, 15th',
    vestingInfo: 'TGE 10%, month unlock - 10%',
    dateTGE: 'TBA',
    distributionInfo: 'TGE - manual distribution, later can be switched to claim',
    saleBlockchain: 'Binance Smart Chain',
    distributionBlockchain: 'Ethereum',
    minimunStake: '5k MILK2',
    maximumStake: '20k MILK2',
    participantsLimit: '1000',
    participationRestrictions: 'TBA',
    // Tokensale page info
    exchangeRate: '1 sSENATE = 0.18 BUSD',
    description:
      'A Futuristic PLAY2EARN NFT MMORPG with an amazing blockchain journey full of adventures and opportunities',
    socialLinks: [
      {
        icon: 'www',
        link: 'https://sidusheroes.com/',
      },
      {
        icon: 'telegram',
        link: 'https://t.me/sidus_heroes',
      },
      {
        icon: 'twitter',
        link: 'https://twitter.com/galaxy_sidus',
      },
      {
        icon: 'discord',
        link: 'https://discord.gg/PGD4bq7jE4',
      },
      {
        icon: 'medium',
        link: 'https://medium.com/sidus-nft-heroes',
      },
      {
        icon: 'youtube',
        link: 'https://www.youtube.com/channel/UCK3TsqpWwMkve49sOZD_gmg/featured',
      },
    ],
    saleType: 'IDO',
    stakeToken: 'milk2',
    progress: 96.5,
    hasClaim: false,
    xxx: 32.55,
    roi: '+3 154.7%',
    isFinished: true,
  },
  penguinkarts: {
    id: 3,
    icon: 'pgk',
    chainId: 56,
    // Token info
    name: 'PenguinKarts',
    tokenTicker: 'PGK',
    address: '0x188a168280589bC3E483d77aae6b4A1d26bD22dC',
    addressLink: 'https://ftmscan.com/token/0x188a168280589bC3E483d77aae6b4A1d26bD22dC',
    totalSupply: '200,000,000 PGK',
    // Pooll info
    totalRaise: '$30,000',
    totalOfferingAmount: '750,000 PGK',
    paymentToken: 'BUSD',
    paymentTokenIcon: 'busd',
    paymentTokenLink: 'https://bscscan.com/token/0xe9e7cea3dedca5984780bafc599bd69add087d56',
    price: '$0.04',
    // Sale campaign details
    time: '07:00 UTC',
    date: 'March 18',
    vestingInfo: '10% 30 min. after TGE - 1 Month cliff, Thereafter 5 months linear',
    dateTGE: '23.03.2022',
    distributionInfo: '10% 30 min delay at TGE',
    saleBlockchain: 'Binance Smart Chain (BSC)',
    distributionBlockchain: 'Fantom (FTM)',
    minimunStake: '5,000',
    maximumStake: '20,000',
    participantsLimit: '150',
    participationRestrictions: 'General',
    // Tokensale page info
    exchangeRate: '1 PGK = 0.04 BUSD',
    description: 'A battle-racing 3D multiplayer game built on the Blockchain. It combines the best elements of arcade style kart racing, mobile gaming and Play-to-Earn NFT dynamics.',
    socialLinks: [
      {
        icon: 'www',
        link: 'https://penguinkarts.com/',
      },
      {
        icon: 'twitter',
        link: 'https://twitter.com/penguinkarts',
      },
      {
        icon: 'telegram',
        link: 'https://t.me/penguinkarts',
      },
      {
        icon: 'discord',
        link: 'https://discord.gg/penguinkarts',
      },
      {
        icon: 'medium',
        link: 'https://medium.com/@penguinkarts',
      },
      {
        icon: 'youtube',
        link: 'https://www.youtube.com/channel/UCG1R9NLOocsKXp8vT-IJOHA',
      },
    ],
    saleType: 'IDO',
    stakeToken: 'milk2',
    progress: 99.9,
    hasClaim: false,
    xxx: 6.83,
    roi: '+582.6%',
    isFinished: true,
  },
  legionnetwork: {
    id: 1,
    icon: 'lgx',
    chainId: 56,
    // Token info
    name: 'Legion Network',
    tokenTicker: 'LGX',
    address: '0x9096B4309224d751FCB43d7eB178dcFFc122aD15',
    addressLink: 'https://bscscan.com/token/0x9096b4309224d751fcb43d7eb178dcffc122ad15',
    totalSupply: '1,000,000,000 LGX',
    // Pooll info
    totalRaise: '$20,000',
    totalOfferingAmount: '266,666.67 LGX',
    paymentToken: 'BUSD',
    paymentTokenIcon: 'busd',
    paymentTokenLink: 'https://bscscan.com/token/0xe9e7cea3dedca5984780bafc599bd69add087d56',
    price: '$0.075',
    // Sale campaign details
    time: '07:00 UTC',
    date: 'April 18',
    vestingInfo: '10% TGE, 15% Monthly after',
    dateTGE: '20.04.2022',
    distributionInfo: 'claim (project website)',
    saleBlockchain: 'BSC',
    distributionBlockchain: 'BSC',
    minimunStake: '5k MILK2',
    maximumStake: '20k MILK2',
    participantsLimit: '100',
    participationRestrictions: 'General',
    // Tokensale page info
    exchangeRate: '1 LGX = 0.075 BUSD',
    description: 'Legion Network is the world’s largest crypto SuperApp that combines NFT’s, Metaverse, Play2Earn, Watch2Earn all within a SuperApp.',
    socialLinks: [
      {
        icon: 'www',
        link: 'https://legionnetwork.io',
      },
      {
        icon: 'twitter',
        link: 'https://twitter.com/LegionNetwork__',
      },
      {
        icon: 'telegram',
        link: 'https://t.me/legionnetworkcommunity',
      },
      {
        icon: 'discord',
        link: 'https://discord.gg/legionnetwork',
      },
      {
        icon: 'medium',
        link: 'https://legionnetwork.medium.com/',
      },
      {
        icon: 'youtube',
        link: 'https://www.youtube.com/c/LegionNetwork',
      },
    ],
    saleType: 'IDO',
    stakeToken: 'milk2',
    progress: 99.9,
    hasClaim: false,
    xxx: 3.93,
    roi: '+293%',
    isFinished: true,
  },
  crypcade_low_fat: {
    id: 3,
    icon: 'icade',
    chainId: 56,
    // Token info
    name: 'CrypCade (Low Fat)',
    tokenTicker: 'iCADE',
    address: '0x4937018b40335A78Baeb47341f772E2fe58955Ae',
    addressLink: 'https://bscscan.com/address/0x4937018b40335A78Baeb47341f772E2fe58955Ae',
    totalSupply: '750,000,000 iCADE',
    // Pooll info
    totalRaise: '$10,000',
    totalOfferingAmount: '250,000 iCADE',
    paymentToken: 'BUSD',
    paymentTokenIcon: 'busd',
    paymentTokenLink: 'https://bscscan.com/token/0xe9e7cea3dedca5984780bafc599bd69add087d56',
    price: '$0.04',
    // Sale campaign details
    time: '07:00 UTC',
    date: 'August 9',
    vestingInfo: '20% at TGE, 3% after 30 days, 5 months linear vesting',
    dateTGE: 'TBA',
    distributionInfo: 'claim on SpaceSwap Starter',
    saleBlockchain: 'BSC',
    distributionBlockchain: 'BSC',
    minimunStake: '10,000 MILK2',
    maximumStake: '29,999 MILK2',
    participantsLimit: '100',
    participationRestrictions: 'General',
    // Tokensale page info
    exchangeRate: '1 iCADE = 0.04 BUSD',
    description: 'CrypCade is a Metaverse as a Service product. CrypCade is the Entertainment Ecosystem that brings ultimate Gaming & Entertainment experience for Users on a Metaverse environment. The CrypCade City Metaverse is separated into 7 sectors. Each with its own unique environment, challenges and rewards. Within the Metaverse, partner dapps or crypto projects will be able to co-build their own dapps and CrypCade users will be able to play their favourite games using the ecosystem’s native token. Exciting P2E games, try your luck in the 100% provably fair Casino, Race against other players in the HOVER racer game and get rewards daily. Own a Property or land and get paid revenue. Hold one of the KEYS and Earn TAX from all the residents in CrypCade city. Interact with REAL WORLD business.',
    socialLinks: [
      {
        icon: 'www',
        link: 'https://crypcade.city',
      },
      {
        icon: 'twitter',
        link: 'https://twitter.com/CrypCade',
      },
      {
        icon: 'telegram',
        link: 'https://t.me/CrypCade',
      },
      {
        icon: 'discord',
        link: 'https://discord.gg/CrypCade',
      },
      {
        icon: 'medium',
        link: 'https://medium.com/@CrypCade',
      },
      {
        icon: 'youtube',
        link: 'https://www.youtube.com/channel/UClY4y5P6j_YqH8F0KkzFWUQ',
      },
    ],
    saleType: 'IDO',
    stakeToken: 'milk2',
    progress: 41.4,
    hasClaim: false,
    xxx: 'TBA',
    roi: 'TBA%',
    isFinished: true,
  },
  crypcade_creamy: {
    id: 4,
    icon: 'icade',
    chainId: 56,
    // Token info
    name: 'CrypCade (Creamy)',
    tokenTicker: 'iCADE',
    address: '0x4937018b40335A78Baeb47341f772E2fe58955Ae',
    addressLink: 'https://bscscan.com/address/0x4937018b40335A78Baeb47341f772E2fe58955Ae',
    totalSupply: '750,000,000 iCADE',
    // Pooll info
    totalRaise: '$10,000',
    totalOfferingAmount: '250,000 iCADE',
    paymentToken: 'BUSD',
    paymentTokenIcon: 'busd',
    paymentTokenLink: 'https://bscscan.com/token/0xe9e7cea3dedca5984780bafc599bd69add087d56',
    price: '$0.04',
    // Sale campaign details
    time: '07:00 UTC',
    date: 'August 9',
    vestingInfo: '20% at TGE, 3% after 30 days, 5 months linear vesting',
    dateTGE: 'TBA',
    distributionInfo: 'claim on SpaceSwap Starter',
    saleBlockchain: 'BSC',
    distributionBlockchain: 'BSC',
    minimunStake: '30,000 MILK2',
    maximumStake: '30,000 MILK2',
    participantsLimit: '50',
    participationRestrictions: 'General',
    // Tokensale page info
    exchangeRate: '1 iCADE = 0.04 BUSD',
    description:
      'CrypCade is a Metaverse as a Service product. CrypCade is the Entertainment Ecosystem that brings ultimate Gaming & Entertainment experience for Users on a Metaverse environment. The CrypCade City Metaverse is separated into 7 sectors. Each with its own unique environment, challenges and rewards. Within the Metaverse, partner dapps or crypto projects will be able to co-build their own dapps and CrypCade users will be able to play their favourite games using the ecosystem’s native token. Exciting P2E games, try your luck in the 100% provably fair Casino, Race against other players in the HOVER racer game and get rewards daily. Own a Property or land and get paid revenue. Hold one of the KEYS and Earn TAX from all the residents in CrypCade city. Interact with REAL WORLD business.',
    socialLinks: [
      {
        icon: 'www',
        link: 'https://crypcade.city',
      },
      {
        icon: 'twitter',
        link: 'https://twitter.com/CrypCade',
      },
      {
        icon: 'telegram',
        link: 'https://t.me/CrypCade',
      },
      {
        icon: 'discord',
        link: 'https://discord.gg/CrypCade',
      },
      {
        icon: 'medium',
        link: 'https://medium.com/@CrypCade',
      },
      {
        icon: 'youtube',
        link: 'https://www.youtube.com/channel/UClY4y5P6j_YqH8F0KkzFWUQ',
      },
    ],
    saleType: 'IDO',
    stakeToken: 'milk2',
    progress: 53.1,
    hasClaim: false,
    xxx: 'TBA',
    roi: 'TBA%',
    isFinished: true,
  },
  sleep: {
    id: 1,
    icon: 'sleep',
    chainId: 56,
    // Token info
    name: 'SLEEP tier 1',
    tokenTicker: '$SLEEP',
    address: '0x70b514801E7e59C24c32a353AC00951BB6979944',
    addressLink: 'https://bscscan.com/address/0x70b514801E7e59C24c32a353AC00951BB6979944',
    totalSupply: '1,000,000,000 SLEEP',
    // Pooll info
    totalRaise: '$5,000',
    totalOfferingAmount: '555,556 $SLEEP',
    paymentToken: 'BUSD',
    paymentTokenIcon: 'busd',
    paymentTokenLink: 'https://bscscan.com/token/0xe9e7cea3dedca5984780bafc599bd69add087d56',
    price: '$0.009',
    // Sale campaign details
    time: '13:00 UTC',
    date: 'September 26',
    vestingInfo: '20% at TGE 3 months linear vesting',
    dateTGE: '6th October',
    distributionInfo: 'TBA',
    saleBlockchain: 'Binance Smart Chain',
    distributionBlockchain: 'Binance Smart Chain',
    minimunStake: '5,000',
    maximumStake: '10,000',
    participantsLimit: '50',
    participationRestrictions: 'General',
    // Tokensale page info
    exchangeRate: '1 SLEEP = 0.009 BUSD',
    description:
      'SLEEP is the first Web3 lifestyle app with Social-Fi and Game-Fi elements where users can earn $ZZZ for sleeping, relaxing, and putting their phones away. Players can choose to rent or sell their NFT beds on the in-app Marketplace; the users SLEEP earnings are stored in the in-app Wallet, which has a built-in Swap function.',
    socialLinks: [
      {
        icon: 'www',
        link: 'https://sleep.game/',
      },
      {
        icon: 'twitter',
        link: 'https://twitter.com/SleepGame_',
      },
      {
        icon: 'telegram',
        link: 'https://t.me/sleepgame',
      },
      {
        icon: 'medium',
        link: 'https://medium.com/@sleepgame',
      },
      {
        icon: 'youtube',
        link: 'https://youtu.be/Q7h033HjnkI',
      },
    ],
    video: 'sleep.mp4',
    saleType: 'SMPL',
    stakeToken: 'milk2',
    progress: 96.8,
    hasClaim: false,
    xxx: 'TBA',
    roi: 'TBA%',
    isFinished: true,
  },
};
